import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './what-is-hsm/HeroSection';
import { BrandLogosSection } from './what-is-hsm/BrandLogosSection';
import { WhatIsHSMSection } from './what-is-hsm/WhatIsHSMSection';
import { HistorySection } from './what-is-hsm/HistorySection';
import { ConventionalVsHSMSection } from './what-is-hsm/ConventionalVsHSMSection';
import { ToolsSection } from './what-is-hsm/ToolsSection';
import { TechniquesSection } from './what-is-hsm/TechniquesSection';
import { MikronMachinesSection } from './what-is-hsm/MikronMachinesSection';
import { MikronDNASection } from './what-is-hsm/MikronDNASection';
import { CharacteristicsSection } from './what-is-hsm/CharacteristicsSection';
export function WhatIsHSMPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-4402">
      <SeoBar data-id="element-4403" />
      <Header data-id="element-4404" />
      <main className="flex-grow" data-id="element-4405">
        <div className="w-full bg-gray-50 pb-20" data-id="element-4406">
          <HeroSection data-id="element-4407" />
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-4408">
            <BrandLogosSection data-id="element-4409" />
            <WhatIsHSMSection data-id="element-4410" />
            <HistorySection data-id="element-4411" />
            <ConventionalVsHSMSection data-id="element-4412" />
            <ToolsSection data-id="element-4413" />
            <TechniquesSection data-id="element-4414" />
            <MikronMachinesSection data-id="element-4415" />
            <MikronDNASection data-id="element-4416" />
            <CharacteristicsSection data-id="element-4417" />
          </div>
        </div>
      </main>
      <Footer data-id="element-4418" />
    </div>;
}